// extracted by mini-css-extract-plugin
module.exports = {"container__text":"styles-skeleton_container__text__8LpEz","skeleton-animation":"styles-skeleton_skeleton-animation__TcBqS","container":"styles-skeleton_container__Idy_g"};